<div class="banner1">
    <div class="banner">
       <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
    
                            <div class="p-3" style="max-width: 900px;">
                                <img src="/assets/img/whiteicon.png " class = "logo">
                                <h5  >Robo-Advisor</h5>
                                <h1 class="text-white text-uppercase mb-3 animated slideInDown">Votre Compte est vérifié</h1>
                                <h4 class = "hidemob" >Vous pouvez maintenant bénificier des focntionnalités du Robo-Advisor</h4>
                             
                                <a routerLink="/login" class="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"> Se connecter</a>
                       
                            </div>
       </div>
    </div>
    </div>